import clsx from "clsx";
import { RouterProvider } from "react-router-dom";
import { router } from "../routes";
import { DesktopNav, MobileNav } from "../components";

export default function AppBase() {
  const homepage = window.location.pathname === "/";
  const artists4Page = window.location.pathname === "/artistsforpeople";
  
  const routesInnerStyle = clsx(
    routesInnerContainer + ((homepage || artists4Page) ? " w-full" : " lg:w-4/5")
  );
  return (
    <>
      <div className={parentContainer}>
        {!artists4Page && (
          <>
            <MobileNav />
            <DesktopNav />
          </>
        )}
        <div className={routesContainer}>
          <div className={routesInnerStyle}>
            <RouterProvider router={router} />
          </div>
        </div>
      </div>
    </>
  );
}

const parentContainer = clsx(
  "lg:h-screen flex flex-col lg:flex-row justify-content items-center relative w-full bg-creme"
);
const routesContainer = clsx(
  "flex flex-col w-full items-center lg:h-screen lg:overflow-y-scroll"
);
const routesInnerContainer = clsx("flex flex-col ");
